import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PSF_SHARE_MESSAGE_BUTTON_ORDER = createFcmDetails('psf_share_message_button_order', {
	owner: 'TBD',
	context: 'PSF share page',
	description: 'Used to configure the buttons being displayed on the PSF page (non-initial) and their order',
	import: false,
	template: ['copy', 'whatsapp', 'line', 'facebookMessenger', 'twitter', 'email', 'sms'],
});
